import { jsx as _jsx } from "react/jsx-runtime";
import 'react';
import toLower from 'lodash/fp/toLower';
const SortArrows = ({ direction }) => (_jsx("span", { className: `sort-arrows ${direction ? `sort-${toLower(direction)}` : ''}` }));
export default SortArrows;
